// @owners { team: patients }
import { Body, Column, H1, LgSpacing, XsSpacing, XxxxxlSpacing } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';
import { getImage } from '~shared/assets/images/getImage';

const StyledAltoBox = styled.div`
  display: flex;
  max-height: 465px;
  max-width: 357px;
  margin: auto;

  img {
    width: 100%;
    margin: 0;
    vertical-align: top;
  }
`;

type Props = {
  readonly title: string;
};

export default function NoNewUpdates({ title }: Props) {
  return (
    <Column center>
      <XxxxxlSpacing />
      <H1>{title}</H1>
      <XsSpacing />
      <Body>New medications and orders will appear here.</Body>
      <LgSpacing />
      <StyledAltoBox>
        <img
          alt="Box with meds"
          src={getImage('boxRotated')}
        />
      </StyledAltoBox>
    </Column>
  );
}
